import {ChangeDetectionStrategy, Component, effect, Injectable, input, signal, viewChild} from "@angular/core";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {TranslateModule} from "@ngx-translate/core";
import {KortKomponent} from "web-ng2/delt/komponenter/kort/kort";
import {KortHandlingerKomponent} from "web-ng2/delt/komponenter/kort/kort-handlinger/kort-handlinger";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";
import {StandardValideringsfeilPipe} from "felles-ng2/pipes/StandardValideringsfeilPipe";
import {FeltValidatorer} from "felles-ng2/infrastruktur/angular/feltValidatorer";
import {asynkArbeidPågårSignal} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {EnkelGruppeModell, GruppeId, ProtokollValgSpesifikasjon} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {GruppeDatatjeneste} from "felles-ng2/tjenester/datalager/GruppeDatatjeneste";
import {KortTittelKomponent} from "web-ng2/delt/komponenter/kort/kort-tittel/kort-tittel";
import {TittelVerdiSamlingKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi-samling";
import {TittelVerdiKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi";
import {MatIcon} from "@angular/material/icon";

@Component({
    selector: 'gruppe-protokoll-oppsett',
    templateUrl: 'gruppe-protokoll-oppsett.html',
    styleUrl: 'gruppe-protokoll-oppsett.scss',
    host: {'data-testid': 'gruppe-protokoll-oppsett'},
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule, MatInputModule, MatButtonModule,
        KortKomponent, KortHandlingerKomponent,
        VisSpinnerDirektiv,
        StandardValideringsfeilPipe,
        TranslateModule, KortTittelKomponent, TittelVerdiSamlingKomponent, TittelVerdiKomponent, MatIcon,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GruppeProtokollOppsettKomponent {

    kortKomp = viewChild.required(KortKomponent);

    gruppe = input.required<EnkelGruppeModell>();

    erRedigeringsmodus = signal(false);
    lagrer = asynkArbeidPågårSignal();

    skjema = new FormGroup({
        beslutningOrdlydEntall: new FormControl('', {nonNullable: true, validators: FeltValidatorer.litenIkkeTomStreng}),
        beslutningOrdlydFlertall: new FormControl('', {nonNullable: true, validators: FeltValidatorer.litenIkkeTomStreng}),
    });

    constructor(private avhengigheter: GruppeProtokollOppsettKomponentAvhengigheter) {
        effect(() => this.skjema.patchValue({
            beslutningOrdlydEntall: this.gruppe().oppsett.protokollValg.beslutningOrdlydEntall,
            beslutningOrdlydFlertall: this.gruppe().oppsett.protokollValg.beslutningOrdlydFlertall,
        }));
    }

    rediger() {
        this.erRedigeringsmodus.set(true);
        this.kortKomp().setSomAktivOgSkrollTil();
    }

    avbrytRedigering() {
        this.aktiverVisningsmodus();
    }

    async lagre() {
        const spesifikasjon: ProtokollValgSpesifikasjon = {
            beslutningOrdlydEntall: this.skjema.controls.beslutningOrdlydEntall.value,
            beslutningOrdlydFlertall: this.skjema.controls.beslutningOrdlydFlertall.value,
        };
        await this.lagrer.utfør(() =>
            this.avhengigheter.oppdaterProtokollValg(this.gruppe().id, spesifikasjon));

       this.aktiverVisningsmodus();
    }

    //private hjeloemetoder

    private aktiverVisningsmodus() {
        this.erRedigeringsmodus.set(false);
        this.kortKomp().setSomIkkeAktiv();
    }
}

@Injectable()
export class GruppeProtokollOppsettKomponentAvhengigheter {
    constructor(private gruppeDatatjeneste: GruppeDatatjeneste) {}

    async oppdaterProtokollValg(gruppeId: GruppeId, spesifikasjon: ProtokollValgSpesifikasjon): Promise<void> {
        await this.gruppeDatatjeneste.oppdaterProtokollValg(gruppeId, spesifikasjon);
    }
}
